import { render, staticRenderFns } from "./add.vue?vue&type=template&id=49a2f570&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=49a2f570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2f570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a2f570')) {
      api.createRecord('49a2f570', component.options)
    } else {
      api.reload('49a2f570', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=49a2f570&scoped=true&", function () {
      api.rerender('49a2f570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/speaking/components/add.vue"
export default component.exports